import { ApiError } from '@/error-handler/ApiError';
import { v1ApiClient } from '@/services';

import type { SharedLink, SharedLinkTargetType } from './types';

type CheckSharedLinkExistsParams = {
  workspaceId: string;
  targetId: string;
  targetType: SharedLinkTargetType;
};

type CheckSharedLinkExistsResponse = SharedLink | null;

export const checkSharedLinkExists = async ({
  workspaceId,
  targetId,
  targetType,
}: CheckSharedLinkExistsParams): Promise<CheckSharedLinkExistsResponse> => {
  try {
    const response = await v1ApiClient.post(
      `/workspaces/${workspaceId}/shared-link/exists`,
      {
        target_id: targetId,
        target_type: targetType,
      },
    );

    return response.data;
  } catch (error) {
    const client_code =
      error instanceof ApiError ? error.data.client_code : null;

    if (client_code === 'shared_link__not_exists') {
      return null;
    }

    throw error;
  }
};
